import { render, staticRenderFns } from "./ParticipantsField.vue?vue&type=template&id=355912f4"
import script from "./ParticipantsField.vue?vue&type=script&lang=js"
export * from "./ParticipantsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports